import React, { useEffect, useState } from 'react'
import { Row, Form } from 'rsuite'
import InputForm from '../../../components/forms/input/InputForm'

export default function ManageMasterDataForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    console.log('clear value')
    if (!clearValue) {
      console.log('clear value is true')
      setValue(schema.name.name, '')
      setValue(schema.sequence.name, '')
      setSchema(_schema)
    }
  }, [clearValue, _schema])

  return (
    <>
      <Form fluid>
        <Row>
          <InputForm
            schema={schema.name}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Row>

        {schema.isSequence && (
          <Row>
            <InputForm
              schema={schema.sequence}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              isInputNumber
            />
          </Row>
        )}
      </Form>
    </>
  )
}
